import { useEffect, useState } from 'react';

export function useStableArray<TInput>(input: TInput[] | undefined) {
  const [stableArray, updateStableArray] = useState(input);
  useEffect(() => {
    if (JSON.stringify(input) !== JSON.stringify(stableArray)) {
      updateStableArray(input);
    }
  }, [input, stableArray]);
  return stableArray;
}
